// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"5b6cabd3","453":"b88efcb5"}[chunkId] + ".chunk.js";
};